import getValidator from './getValidator';

const deselectIf = (config) => (value) => {
  const validator = getValidator(config.validator);
  return validator({ ...config, value: config.validatorValue })(value);
};

export default deselectIf;
